'use client';

import { IconButton, styled } from '@mui/material';

export const StyledScrollToTopButton = styled(IconButton)(({ theme }) => ({
  position: 'fixed',
  bottom: 24,
  right: 24,
  zIndex: 1300,
  width: 48,
  height: 48,
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
  },
  [theme.breakpoints.down('sm')]: {
    bottom: 16,
    right: 16,
    width: 40,
    height: 40,
  },
}));
